import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const getDCCostManualPullUserUploads = async () => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const email = tokenInfo.email || tokenInfo.username;
  if (!email) {
    AlertManager.error("User email is required", { contactSupport: false });
    return [];
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.dcCostManualPullUserUploads}?email=${encodeURIComponent(email)}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);

    if (response?.ok) {
      return response.json().catch(() => []);
    }

    const errorData = await response?.json?.().catch(() => ({}));
    AlertManager.error(errorData?.message || "Unable to load manual pull data.", { contactSupport: false });
    return [];
  } catch (error) {
    AlertManager.error("Unable to load manual pull data.", { contactSupport: false });
    return [];
  }
};

export default getDCCostManualPullUserUploads;
